import React from "react";
import { Modal } from "react-bootstrap";

export const PrivacyPolicy = ({ show, onClear }) => (
  <Modal show={show} onHide={onClear} title="Privacy Policy">
    <Modal.Header>Privacy Policy</Modal.Header>
    <Modal.Body>
      <p>
        This Privacy Policy governs the manner in which IBorrowDesk collects,
        uses, maintains and discloses information collected from users (each, a
        "User") of the IBorrowDesk website ("website").
      </p>

      <p>
        We may collect personal identification information from Users in a
        variety of ways, including, but not limited to, when Users visit our
        website, or registers on the website.
      </p>

      <p>
        We may collect non-personal identification information about Users
        whenever they interact with our website. Non-personal identification
        information may include the IP address of the User.
      </p>

      <p>
        IBorrowDesk may use "cookies" to enhance User experience. User's web
        browser places cookies on their hard drive for record-keeping purposes
        and sometimes to track information about them. User may choose to set
        their web browser to refuse cookies, or to alert you when cookies are
        being sent. If they do so, note that some parts of the website may not
        function properly.
      </p>

      <p>
        IBorrowDesk may collect and use Users personal information for the
        following purposes:
      </p>

      <p>
        To personalize user experience - we may use information in the aggregate
        to understand how our Users as a group use the services and resources
        provided on our website.
      </p>

      <p>
        To improve our website - we may use feedback you provide to improve our
        products and services.
      </p>

      <p>
        We adopt appropriate data collection, storage and processing practices
        and security measures to protect against unauthorized access,
        alteration, disclosure or destruction of your personal information,
        username, password and email address stored on our website.
      </p>

      <p>
        We do not sell, trade, or rent Users personal identification information
        to others. We may share generic aggregated demographic information not
        linked to any personal identification information regarding visitors and
        users with our advertisers for the purposes outlined above.
      </p>

      <p>
        Users may find advertising or other content on our website that link to
        the websites and services of our partners, suppliers, advertisers,
        sponsors, licensors and other third parties. We do not control the
        content or links that appear on these websites and are not responsible
        for the practices employed by websites linked to or from our website. In
        addition, these websites or services, including their content and links,
        may be constantly changing. These websites and services may have their
        own privacy policies and customer service policies. Browsing and
        interaction on any other website, including websites which have a link
        to our website, is subject to that website's own terms and policies.
      </p>

      <p>
        Ads appearing on our website may be delivered to Users by advertising
        partners, who may set cookies. These cookies allow the ad server to
        recognize your computer each time they send you an online advertisement
        to compile non personal identification information about you or others
        who use your computer. This information allows ad networks to, among
        other things, deliver targeted advertisements that they believe will be
        of most interest to you. This privacy policy does not cover the use of
        cookies by any advertisers.
      </p>

      <p>
        Some of the ads may be served by Google. Google's use of the DART cookie
        enables it to serve ads to Users based on their visit to our website and
        other websites on the Internet. DART uses "non personally identifiable
        information" and does NOT track personal information about you, such as
        your name, email address, physical address, etc. You may opt out of the
        use of the DART cookie by visiting the Google ad and content network
        privacy policy at https://www.google.com/privacy_ads.html
      </p>

      <p>
        IBorrowDesk has the discretion to update this privacy policy at any
        time. When we do, we will revise the updated date at the bottom of this
        page. We encourage Users to frequently check this page for any changes
        to stay informed about how we are helping to protect the personal
        information we collect. You acknowledge and agree that it is your
        responsibility to review this privacy policy periodically and become
        aware of modifications.
      </p>

      <p>
        By using this website, you signify your acceptance of this policy and
        terms of service. If you do not agree to this policy or terms, please do
        not use our website. Your continued use of the website following the
        posting of changes to this policy will be deemed your acceptance of
        those changes.
      </p>

      <p>
        If you have any questions about these Terms of Service, the practices of
        this website, or your dealings with this website, please email
        iborrowdesk@gmail.com
      </p>
    </Modal.Body>
  </Modal>
);
